import { FC } from 'react'

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

type Props = {
  children: string
}

const ShortenedRef: FC<Props> = ({ children }) => {
  if (children.length <= 12) {
    return <span className="font-mono">{children}</span>
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="font-mono cursor-pointer select-all">
            {children.slice(0, 6)}
            <span className="text-xs text-muted-foreground">...</span>
            {children.slice(-6)}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <span className="font-mono">{children}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default ShortenedRef
